<template>
  <div>
    <div class="tour ui-container">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="ui-title ui-title--uppercase ui-title--white">
              <b>
                Tour 360°
              </b>
            </h1>
          </div>
          <div class="col-12">
            <carousel
            v-if="empreendimentoApartamentos.length >= 1"
            :per-page="1"
            :paginationPadding="5"
            :paginationSize="15"
            :paginationActiveColor="'#fff'"
            :perPageCustom="[[480, 1], [768, 2], [1024, 3]]"
            :loop="false"
            :autoplay="false"
            >
              <slide v-for="(apartment,index) in empreendimentoApartamentos" v-if="apartment.rooms.length > 0"
              :key="index">
                <div class="tour__itens">
                  <div class="tour__box" :class="{'active' : apartment.id == tabOne}" @click="aciveTab(apartment.id)">
                    {{apartment.name}}
                  </div>
                </div>
              </slide>
            </carousel>
            <div class="tour__subitens carousel_tour">
              <carousel
              class="row align-items-center justify-content-center"
              v-for="(apartment,index) in empreendimentoApartamentos"
              :key="index"
              v-show="tabOne == apartment.id"
              :per-page="1"
              :paginationPadding="5"
              :paginationSize="15"
              :paginationActiveColor="'#fff'"
              :perPageCustom="[[480, 1], [768, 3], [1024, 6]]"
              :loop="false"
              :autoplay="false"
              :paginationEnabled="false"
              :navigationEnabled="true"
              navigationNextLabel='<i class="fa fa-chevron-right left_tour"></i>'
              navigationPrevLabel='<i class="fa fa-chevron-left right_tour" aria-hidden="true"></i>'
              >
                <slide v-for="(room,index) in apartment.rooms" :key="index">
                  <div @click="acivesubTab(room)" :class="{'active' : room.id == subtabOne}" class="room_tab">
                    {{room.name}}
                  </div>
                </slide>
              </carousel>
              <!-- <ul class="row align-items-center justify-content-center"
              v-for="(apartment,index) in empreendimentoApartamentos"
              :key="index"
              v-show="tabOne == apartment.id"
              >
                <li
                  v-for="(room,index) in apartment.rooms"
                  :key="index"
                  :class="{'active' : room.id == subtabOne}"
                  @click="acivesubTab(room)"
                  >
                  {{room.name}}
                </li>
              </ul> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-for="(apartment,index) in empreendimentoApartamentos" :key="index"
      v-show="tabOne == apartment.id"
    >
      <div
        class=" w-100"
        v-for="(apartment,index) in apartment.itens"
        :key="index"
        v-show="apartment.id == subtabOne"
      >
      </div>
    </div>
    <div class="tab">
      <div class="tour__imagem w-100">
        <iframe :src="imagemPano" height="100%" width="100%" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      isPanoShowing: true,
      tabOne: 1,
      subtabOne: 1,
      imagemPano: ''
    }
  },
  components: {
    Carousel,
    Slide
  },
  methods: {
    aciveTab (a) {
      this.tabOne = a
    },
    acivesubTab (item) {
      this.isPanoShowing = false
      this.subtabOne = item.id
      this.imagemPano = item.image
    }
  },
  computed: {
    ...mapGetters([
      'empreendimentoApartamentos'
    ])
  },
  created () {
    this.$store.dispatch('showEmpreendimentoApartamentos', this.$route.params.slug)
      .then(() => {
        for (var i = 0; i < this.empreendimentoApartamentos.length; i++) {
          if (this.empreendimentoApartamentos[i].rooms.length > 0) {
            this.acivesubTab(this.empreendimentoApartamentos[i].rooms[0])
            this.aciveTab(this.empreendimentoApartamentos[i].id)
            return true
          }
        }
      })
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';
.tour.ui-container{
  padding-bottom: 0px;
}
.room_tab{
  padding-bottom: 80px;
  cursor: pointer;
  text-transform: uppercase;
}
.tour {
  background: $primary;
  h1 {
    margin-bottom: 40px;
  }
  &__itens {
    padding: 0 10px;
  }
  &__box {
    background: transparent;
    border-radius: 5px;
    border: 2px $tabs solid;
    color: $tabs;
    cursor: pointer;
    overflow: hidden;
    padding: 10px 40px;
    position: relative;
    text-align: center;
    text-transform: uppercase;
  }
  .active {
    border-color: white;
    border-bottom-color: $green;
    border-radius: 5px 5px 0 0;
    color: white;
    font-weight: 600;
    &:before {
      background: $green;
      bottom: 0;
      content: '';
      height: 5px;
      left: 0;
      position: absolute;
      width: 100%;
    }
  }
  &__subitens {
    margin-top: 40px;
    li {
      color: white;
      cursor: pointer;
      font-weight: 300;
      margin: 0 15px;
      text-align: center;
      text-transform: uppercase;
      transition: all 0.3s;
      padding: 1.2em 0;
      @media (max-width: 767px){
        margin: 5px 15px;
      }
    }
    .VueCarousel-slide{
      color: #fff;
      text-align: center;
    }
    .active {
      font-weight: 900;
      transition: all 0.3s;
      position: relative;
      padding-bottom: 80px;
      text-align: center;
      &:before {
        bottom: 0px;
      }
    }
  }
  &__imagem {
    height: 600px;
    cursor: url(../../assets/img/cursor.png);
  }
  @media (max-width: 1400px){
    &__imagem {
      height: 450px;
    }
  }
  @media (max-width: 767px){
    &__imagem {
      height: 400px;
    }
  }
}
.tab {
  min-height: 600px;
}
@media (max-width: 1400px){
  .tab {
    min-height: 350px;
  }
}
@media (max-width: 767px){
  .tab {
    min-height: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/empreendimentos/InternaTour.vue